import fetchIntercept from 'fetch-intercept';
import { isExpired, decodeToken } from "react-jwt";

const unregister = fetchIntercept.register({
    request: function (url, config) {
        // Modify the url or config her
        config.headers.append("Content-Type", "application/json");
        config.headers.append("Authorization", "Bearer " + localStorage.getItem('token'));
        config.headers.append("Environment", localStorage.getItem("modoproductivo"));

        /*var token = localStorage.getItem('token');
        var isMyTokenExpired = isExpired(token);
        var token = localStorage.setItem("tokenValidate", isMyTokenExpired);
        console.log(isMyTokenExpired);
        if (isMyTokenExpired) {
            window.location = "/"
        }*/

        //console.log(url);
        return [url, config];
    },

    requestError: function (error) {
        // Called when an error occured during another 'request' interceptor call
        console.log(error);
        return Promise.reject(error);
    },

    response: function (response) {
        // Modify the reponse object
        //console.log(response);
        //console.log(JSON.stringify(response));
        
        response
            .clone()
            .json()
            .then(body => {
                //console.log("intercepted response:", body);
                var token = body.tokenNew;
                if ((response.status != 401 || response.status != 500) && token != null) {
                    localStorage.setItem('token', token)
                }
                
            })
            .catch(err => console.error(err))
            ;
        if (response.status == 401) {
            localStorage.clear();
            window.location = "/"
            
        }
        
        return response;
    },

    responseError: function (error) {
        // Handle an fetch error
        console.log(error);
        return Promise.reject(error);
    }
});

export default unregister;